import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import NavigationBar from 'components/Navigation';
import ConfirmModal from 'components/ConfirmModal';
import * as S from './WithdrawAccount.styled';
import { memberService } from 'services/memberService';
import viewIcon from 'assets/SignupImage/view.png';

function WithdrawAccount() {
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isWithdrawing, setIsWithdrawing] = useState<boolean>(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleWithdrawClick = () => {
    if (!password) {
      alert('비밀번호를 입력해주세요.');
      return;
    }
    setIsConfirmModalOpen(true);
  };

  const handleConfirmWithdraw = async () => {
    setIsConfirmModalOpen(false);
    setIsWithdrawing(true);

    try {
      await memberService.withdraw(password);
      // 탈퇴 성공 - 토큰 삭제 및 탈퇴 완료 페이지로 이동
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      navigate('/withdraw-complete');
    } catch (error) {
      console.error('회원 탈퇴 실패:', error);
      alert('회원 탈퇴에 실패했습니다. 비밀번호를 확인해주세요.');
    } finally {
      setIsWithdrawing(false);
    }
  };

  const handleCancelWithdraw = () => {
    setIsConfirmModalOpen(false);
  };

  return (
    <S.Body>
      <S.Header>
        <S.BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </S.BackButton>
        회원탈퇴
      </S.Header>

      <S.ContentWrap>
        <S.Description>본인인증을 위해 현재 비밀번호를 입력해주세요.</S.Description>

        <S.Label>현재 비밀번호</S.Label>
        <S.InputContainer>
          <S.Input
            type={showPassword ? "text" : "password"}
            placeholder="영문, 숫자 포함 7~15자리"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <S.PasswordToggleButton
            type="button"
            onClick={() => setShowPassword(!showPassword)}
          >
            <S.PasswordToggleIcon src={viewIcon} alt="비밀번호 보기" />
          </S.PasswordToggleButton>
        </S.InputContainer>
      </S.ContentWrap>

      <S.BottomButton onClick={handleWithdrawClick} disabled={isWithdrawing}>
        {isWithdrawing ? '탈퇴 중...' : '회원탈퇴'}
      </S.BottomButton>

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        title="회원 탈퇴"
        message="정말 탈퇴하시겠습니까? 모든 데이터가 삭제되며 복구할 수 없습니다."
        confirmText="탈퇴"
        cancelText="취소"
        onConfirm={handleConfirmWithdraw}
        onCancel={handleCancelWithdraw}
      />

      <NavigationBar />
    </S.Body>
  );
}

export default WithdrawAccount;
